import {mergeConfig} from '../../configStore'
import {reference} from '../types'
import type {CategoryField, FieldReturn} from '../../types'

const defaultProps: Partial<CategoryField> = {
  name: 'category',
}

export const category = (
  types: string | string[],
  props?: CategoryField,
  mergeProps?: Partial<CategoryField>,
): FieldReturn => reference(types, mergeConfig('category', props, mergeProps, defaultProps))
